export default __webpack_public_path__ + "96993d0d82078fc8faaffe4ce3d62fe0.svg";